<div class="container">
        <h1><strong>Projects</strong></h1>
        <span class="bar-title mb-5"></span>
        <div class="row">
            <div class="col-lg-4 col-sm-12 d-flex" data-aos="flip-up">
                <div class="card shadow-lg p-3 mb-5 bg-white rounded">
                    <div class="card-header d-flex flex-column " style="height: 300px;width: 100%; ">
                        <div id="fyp-img" class="img-wrap" style="height: 300px;width: 100%;  "
                            [ngStyle]="{backgroundImage:'url(assets/images/fyp.jpg)'}">
                        </div>
                    </div>
                    <div class="card card-body d-flex">
                        <h1 class="card-title"><b>Automatic Question Generator & Short Answer Grading System</b></h1>

                        <p class="card-text">This is our level 4 ongoing research project which is a system to automatically generate MCQ type questions,
                          short answer questions and automatically grade short answer type questions.  Machine Learning, Deep Learning, NLP technologies
                          are used to develop this system</p>
                    </div>
                </div>
            </div>
          <div class="col-lg-4 col-sm-12 d-flex" data-aos="flip-up">
            <div class="card shadow-lg p-3 mb-5 bg-white rounded">
              <div class="card-header d-flex flex-column " style="height: 300px;width: 100%; ">
                <div id="grit-img" class="img-wrap" style="height: 300px;width: 100%;  "
                     [ngStyle]="{backgroundImage:'url(assets/images/grit.jpg)'}">
                </div>
              </div>
              <div class="card card-body d-flex">
                <h1 class="card-title"><b>Grit Search</b></h1>
                <p class="card-text">A recruitment platform which focuses on identifying and securing the top
                  talent in digital, technology, and transformation for high-calibre positions.
                  In this project, I worked on improvements, infrastructure updates, feature releases, and testing.
                  The technologies such as: Typescript-based NodeJS, React JS, Redis, Elastic search engine, JEST
                  were used in the development and testing of this project
                </p>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-sm-12 d-flex" data-aos="flip-up">
            <div class="card shadow-lg p-3 mb-5 bg-white rounded">
              <div class="card-header d-flex flex-column " style="height: 300px;width: 100%; ">
                <div id="hr-tool-img" class="img-wrap" style="height: 300px;width: 100%;  "
                     [ngStyle]="{backgroundImage:'url(assets/images/hr-tool.png)'}">
                </div>
              </div>
              <div class="card card-body d-flex">
                <h1 class="card-title"><b>Internal Online Human Resource Management system</b></h1>

                <p class="card-text">A HR tool which includes User account management module, Leave management module,
                  Resource booking module, Resource repository, Blog, Quizzes and Survey, Finance management module and
                  Task management module.</p>
                <!-- <div class="d-flex flex-row justify-content-center mt-auto">
                    <a href="#" target="_blank" target="_blank" type="button"
                        class="btn btn-primary mr-3">GitHub</a>
                </div> -->
              </div>
            </div>
          </div>
            <div class="col-lg-4 col-sm-12 d-flex" data-aos="flip-up">
                <div class="card shadow-lg p-3 mb-5 bg-white rounded">

                    <div class="card-header d-flex flex-column " style="height: 300px;width: 100%; ">
                        <div id="cdp-img" class="img-wrap" style="height: 300px;width: 100%;  "
                            [ngStyle]="{backgroundImage:'url(assets/images/career.jpg)'}">
                        </div>
                    </div>
                    <div class="card card-body d-flex">
                        <h1 class="card-title"><b>Career Development Portal</b></h1>

                        <p class="card-text">A career guidance portal to facilitate career guidance including the
                            features such as: connect resource persons and needed students/ parents, connect job seekers
                            and job providers, event management, Psychometric tests/ self-evaluation tests, post blogs/
                            videos,
                            global search etc.</p>
                        <!-- <div class="d-flex flex-row justify-content-center mt-auto">
                            <a href="https://github.com/Mohamed-Razan/CDP-project-backend" target="_blank" target="_blank" type="button"
                                class="btn btn-primary mr-3">GitHub</a>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-sm-12 d-flex" data-aos="flip-up">
                <div class="card shadow-lg p-3  bg-white rounded">
                    <div class="card-header d-flex flex-column " style="height: 300px;width: 100%; ">
                        <div id="dress_inn-img" class="img-wrap"
                            [ngStyle]="{backgroundImage:'url(assets/images/dress_inn-logo.png)'}">
                        </div>
                    </div>

                    <div class="card card-body d-flex">
                        <h1 class="card-title"><b>Dress_inn App</b></h1>

                        <p class="card-text">A simple web application using Angular, Spring boot and MySQL that will
                            suit for a cloth shop.
                            Through this app admin can add items, delete items, edit items, accept orders and user can
                            order items and add to cart</p>
                        <!-- <div class="d-flex flex-row justify-content-center  mt-auto">
                            <a href="https://github.com/MifdhaMilan/Dress_inn-app-api" target="_blank" target="_blank" type="button"
                                class="btn btn-primary mr-3 ">GitHub</a>
                        </div> -->
                    </div>
                </div>
            </div>
          <div class="col-lg-4 col-sm-12 d-flex" data-aos="flip-up">
            <div class="card shadow-lg p-3  bg-white rounded">
              <div class="card-header d-flex flex-column " style="height: 300px;width: 100%; ">
                <div id="find-tuition-img" class="img-wrap"
                     [ngStyle]="{backgroundImage:'url(assets/images/find-tuition.png)'}">
                </div>
              </div>

              <div class="card card-body d-flex">
                <h1 class="card-title"><b>Find Tuition</b></h1>

                <p class="card-text">A web application that enables a platform to be used by teachers, students and tuition institutes to meet and manage tuition-related activities conveniently.
                  The application is built using the technologies such as: Spring boot, ReactJS, MySQL, Firebase</p>
                <!-- <div class="d-flex flex-row justify-content-center  mt-auto">
                    <a href="https://github.com/MifdhaMilan/Dress_inn-app-api" target="_blank" target="_blank" type="button"
                        class="btn btn-primary mr-3 ">GitHub</a>
                </div> -->
              </div>
            </div>
          </div>

        </div>
    </div>
